import { affiliateOptionsReducer } from './affiliate-options/affiliate-options.reducer';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { environment } from 'src/environments/environment';
import { errorModalReducer } from './error-modal/error-modal.reducer';
import { fullscreenLoaderReducer } from './fullscreen-loader/fullscreen-loader.reducer';
import { SearchDataEffects } from './search-data/search-data.effect';
import { searchDataReducer } from './search-data/search-data.reducer';
import { changedFlightFlagReducer } from './changed-flight-state/changed-flight-state.reducer';
import { sessionReducer } from './session/session.reducer';
import { StateService } from '@shared/services/state/state.service';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreModule } from '@ngrx/store';
import { Reducers } from './state';
import { ChangeFlightStateEffects } from './changed-flight-state/changed-flight-state.effect';
import { selectedOrderReducer } from './selected-order/selected-order.reducer';
import { SelectedOrderEffects } from './selected-order/selected-order.effect';
import { snackBarReducer } from './snack-bar/snack-bar.reducer';
import { commonOrderReducer } from './common-order/common-order.reducer';

const reducers = {
  session: sessionReducer,
  fullscreenLoader: fullscreenLoaderReducer,
  affiliateOptions: affiliateOptionsReducer,
  errorModal: errorModalReducer,
  searchData: searchDataReducer,
  flightChangeFlag: changedFlightFlagReducer,
  selectedOrderData: selectedOrderReducer,
  commonOrderData: commonOrderReducer,
  snackBar: snackBarReducer,
} as Reducers;

@NgModule({
  imports: [
    StoreModule.forRoot(reducers, {
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
      },
    }),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    EffectsModule.forRoot([SearchDataEffects, ChangeFlightStateEffects, SelectedOrderEffects]),
  ],
  providers: [
    StateService,
    {
      provide: APP_INITIALIZER,
      useFactory: (stateService: StateService) => () => stateService.getSavedData(),
      deps: [StateService],
      multi: true,
    },
  ],
})
export class AppStoreModule {}
